import {
  APIProvider,
  ControlPosition,
  Map as GoogleMap,
  MapControl,
  MapMouseEvent,
  Marker,
  useMarkerRef,
} from '@vis.gl/react-google-maps';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';

import { Button } from '@/shared/components/atoms';
import { PlaceAutocompleteClassic } from '@/shared/components/atoms/Map/AutoComplete';
import MapHandler from '@/shared/components/atoms/Map/MapHandler';

const DEFAULT_CENTER = {
  lat: 52.3676,
  lng: 4.9041,
};

const Map: React.FC<IMapProps> = ({ location, handleSetLocation }) => {
  const { t } = useTranslation();

  const [markerRef] = useMarkerRef();

  const [clicks, setClicks] = useState<google.maps.LatLngLiteral>();

  const [selectedPlace, setSelectedPlace] =
    useState<google.maps.places.PlaceResult | null>(null);

  const handleClick = (ev: MapMouseEvent) => {
    if (ev.detail.latLng) {
      setClicks(ev.detail.latLng);
    }
  };

  const onConfirm = () => {
    if (clicks) handleSetLocation(clicks);
  };

  return (
    <APIProvider apiKey={process.env.NEXT_PUBLIC_MAPS_API_KEY as string}>
      <GoogleMap
        style={{ width: '50VW', height: '50VH' }}
        defaultCenter={location || DEFAULT_CENTER}
        defaultZoom={17}
        minZoom={1}
        gestureHandling='greedy'
        disableDefaultUI={false}
        onClick={handleClick}
      >
        <Marker ref={markerRef} position={clicks || location} />
      </GoogleMap>
      <MapControl position={ControlPosition.TOP_CENTER}>
        <PlaceAutocompleteClassic onPlaceSelect={setSelectedPlace} />
      </MapControl>
      <MapHandler place={selectedPlace} />
      <div className='mt-12 flex justify-center'>
        <Button disabled={!clicks} onClick={onConfirm}>
          {t('Set Location')}
        </Button>
      </div>
    </APIProvider>
  );
};

export { Map };
